export default "<p>\r\n  sample-card works!\r\n</p>\r\n";